import { buildUrl, handleResponse } from "./auth";

export const getEvents = () =>
  fetch(buildUrl("/api/events"), {
    credentials: "include",
  }).then(handleResponse);

const eventsApi = { getEvents };

export default eventsApi;
